import type { TournamentState } from '@ps/poker-games-tile-mappers';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './State.scss';
import { STATE_DATA_MAP } from './stateData';

export interface StateProps {
  state: TournamentState;
  className?: string;
}

const State: React.FC<StateProps> = ({ state, className = '' }) => {
  const stateData = STATE_DATA_MAP[state] || STATE_DATA_MAP.default;

  return (
    <div className={classNames(styles.root, className)}>
      <div className={classNames(styles.state, stateData.style)}>
        {stateData.translation && <Translation {...stateData.translation} />}
      </div>
      <div className={stateData.flagStyle} />
    </div>
  );
};

export default State;
